import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import DriveService from "../../../../../services/drive-service";
import StatsRule from "../../../../common/stats-rule";
import FootballStringifier from "../../../../../services/stringifiers/football-stringifier";
import { getPatComplete } from "../../../utils/context-utils";

export default class PatKickStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PatKick &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { summaryContext } =
            FootballStringifier.generateSummary(play, gameContext) || {};

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.kickedBy.teamId,
            playerId: fragment.kickedBy.id,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: fragment.id,
            category: FootballStatsCategory.PAT_KICK,
            values: {
                code: gameContext?.gameConfig?.scoring?.kickPAT,
                attempted: 1,
                completed:
                    play.historyContains(FootballState.PatCompleted) ||
                    getPatComplete(summaryContext, play.contextSnapshot, play)
                        ? 1
                        : 0,
                dropKick: fragment.isDropKick ? 1 : 0
            }
        });
    }
}
